import { App, message } from "antd";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { takeTask } from "store/bailiff/task/dialog/draft_dialog.action";
import { draftDialogRentTaskSelector } from "store/bailiff/task/dialog/draft_dialog.selector";
import { getUnfinishedTask } from "store/bailiff/task/task_count/task_count.action";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
export const useDialogTaken = () => {
  // -------------------------- VAR -----------------------------
  const { message } = App?.useApp();
  // -------------------------- STATE ---------------------------
  const [loading, setLoading] = useState(false);
  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const count = useSelector(draftDialogRentTaskSelector);
  // -------------------------- FUNCTION ------------------------
  const handleTakeTask = () => {
    if (count <= 0) {
      return message.warning(
        "Không còn việc làm nào ở thời điểm hiện tại, xin vui lòng chờ công việc mới",
      );
    }

    setLoading(true);
    dispatch(
      takeTask((res) => {
        setLoading(false);
        if (res?.status === 200) {
          dispatch(getUnfinishedTask());
        }
        if (res?.status === 500) {
          message.error(res?.data);
        }
      }),
    );
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return { loading, handleTakeTask, disabled: count <= 0 };
};
